const MixinTranslate = {
  methods: {
    translateEs() {
      let dictionary = {
        form: {
          text_1: 'Recibe notificaciones meteorológicas y',
          text_2: 'optimiza el riego',
          text_3: 'de tu cultivo.',
          text_4:
            '¿Quieres una mayor producción y aumentar la eficiencia de tu cultivo?',
          text_5:
            'Ingrese su correo electrónico y obtenga los beneficios ahora.',
          text_6: 'Comenzar Ahora',
          text_7: 'Suscríbete en solo 3 pasos',
        },
        formCE: {
          text_1: 'Introduce unos datos y en poco tiempo',
          text_2: 'estarás recibiendo',
          text_3: 'informacióndel día a día',
          text_4: 'sobre',
          text_5: 'el',
          text_6: 'riego óptimo',
          text_7: 'para tu cultivo.',
          btn_1: 'Salir',
          btn_2: 'Regresar',
          btn_3: 'Siguiente',
          btn_4: '¡Comienza la prueba gratuita de 7 días!',
          title_1: 'Datos de Cultivos',
          title_2: 'Información Adicional',
          title_3: 'Suscripción',
        },
        firstStep: {
          label_1: 'Nombre de Finca',
          label_2: 'Tipo de cultivo',
          label_3: 'Latitud',
          label_4: 'Longitud',
          label_5: 'Altitud (m. s. n. m.)',
          placeholder_1: 'Finca',
          placeholder_2: 'Seleccionar',
          placeholder_3: 'Grados Decimales',
          placeholder_4: 'Grados Decimales',
          text_1: 'Seleccione la ubicación de su cultivo en el mapa.',
          text_2:
            'puede comenzar con el nombre de la finca, aldea, municipio y ubicar exactamente el cultivo en el mapa.',
        },
        secondStep: {
          text_1: '¿Tienes una estación meteorológica?',
          text_2:
            'Si tiene una estación meteorológica y nos proporciona su referencia, podremos procesar los datos meteorológicos con mayor precisión. Si no dispone de uno, se los conseguiremos en la estación privada más cercana',
          text_3: '¿Donde encuentro la referencia?',
          text_4: '¿Tienes sensores de suelo?',
          label_1: 'No',
          label_2: 'Si',
          label_3: 'Agregar la referencia de la estación en otro momento',
          label_4: 'Agregar la referencia del sensor en otro momento',
          placeholder_1: 'Escriba aquí la referencia de la estación',
          placeholder_2: 'Escriba aquí la referencia del Sensor',
          btn_1: 'Eliminar',
          btn_2: 'Salir',
        },
        threeStep: {
          text_1:
            'Comience su prueba GRATUITA de 7 días de notificaciones de riego.',
          text_2: '¡Puedes cancelar el servicio cuando quieras!',
          text_3:
            'Pago: Al 8° día se realiza el cargo en su tarjeta de crédito según el tipo de plan que esté activado.',
          label_1: 'Suscripción mensual USD 14',
          label_2: 'Pago anual de USD 168',
        },
        language: 'Es',
      };
      return dictionary;
    },

    translateEn() {
      let dictionary = {
        form: {
          text_1: 'Receive weather notifications and',
          text_2: 'optimize the irrigation',
          text_3: 'of your crop.',
          text_4:
            'Do you want a higher production and increase the efficiency of your crop?',
          text_5: 'Enter your email and get the benefits now.',
          text_6: 'Start now',
          text_7: 'Subscribe in just 3 steps',
        },
        formCE: {
          text_1: 'Enter some data and in a short time',
          text_2: 'you will be receiving',
          text_3: 'day-to-day information',
          text_4: 'about',
          text_5: 'the',
          text_6: 'optimal irrigation',
          text_7: 'for your crop.',
          btn_1: 'Go out',
          btn_2: 'Previous',
          btn_3: 'Next',
          btn_4: 'Start your 7-day free trial!',
          title_1: 'Crop Data',
          title_2: 'Additional Information',
          title_3: 'Subscription',
        },
        firstStep: {
          label_1: 'Farm Name',
          label_2: 'Type of crop',
          label_3: 'Latitude',
          label_4: 'Longitude',
          label_5: 'Altitude (m. s. n. m.)',
          placeholder_1: 'Farm',
          placeholder_2: 'Select',
          placeholder_3: 'Decimal Degrees',
          placeholder_4: 'Decimal Degrees',
          text_1: 'Select the location of your crop on the map.',
          text_2:
            'You can start with the name of the farm, village, municipality and exactly locate the crop on the map.',
        },
        secondStep: {
          text_1: 'Do you have a weather station?',
          text_2:
            'If you have a weather station and provide us with its reference, we will be able to process the weather data more accurately. If you dont have one, well get it for you at the nearest private station',
          text_3: 'Where do I find the reference?',
          text_4: 'Do you have soil sensors?',
          label_1: 'No',
          label_2: 'Yes',
          label_3: 'Add the station reference at another time',
          label_4: 'Add sensor reference later',
          placeholder_1: 'Enter the station reference here',
          placeholder_2: 'Enter the Sensor reference here',
          btn_1: 'Delete',
          btn_2: 'Exit',
        },
        threeStep: {
          text_1: 'Start your FREE 7-day trial of watering notifications.',
          text_2: 'You can cancel the service whenever you want!',
          text_3:
            'Payment: On the 8th day your credit card is charged according to the type of plan that is activated.',
          label_1: 'Monthly subscription USD 14',
          label_2: 'Annual payment of USD 168',
        },
        language: 'En',
      };

      return dictionary;
    },

    translateDataBaseText(originalName, translateValues) {
      if (!translateValues) return originalName;
      const languages = JSON.parse(translateValues);
      const locale = this.$i18n.locale;
      if (locale === 'es') return originalName;
      else {
        try {
          if (languages[locale]) return languages[locale];
          else return originalName;
        } catch (error) {
          console.log(error);
          return originalName;
        }
      }
    },
  },
};

export default MixinTranslate;
